import { ProductoColaboradorDTO, setListProductoColaborador } from "./ColaboradorProdcutoDTO";
import { FileModel } from "./FileModel";
import { ProductoArchivo, setListProductoArchivo } from "./ProductoArchivo";
import { ProductoAreaConocimientoDTO, getVoidProductoAreaConocimientoDTO, setProductoAreaConocimientoDTO } from "./ProductoAreaConocimientoDTO";
import { GetVoidAreaImplementacion, ProductoAreaImplementacion, setAreaImplementacion } from "./ProductoAreaImplementacionDTO";
import { GetVoidTDecInvProductoScholarMetric, ProductoFactorImpacto, SetListProductoFactorImpacto, SetTDecInvProductoScholarMetric, TDecInvProductoScholarMetric } from "./ProductoFactorImpacto";
import { ProductoInstitucionPais, getVoidProductoInstitucionPais, setProductoInstitucionPais } from "./ProductoInstitucionPaisDTO";
import { ProductoLineaInvestigacionDTO, getVoidProductoLineaInvestigacionDTO, setProductoLineaInvestigacionDTO } from "./ProductoLineaInvestigacionDTO";
import { ProductoObjEspecifico, setListProductoEspecifico } from "./ProductoObjEspecificoDTO";
import { GetVoidProductoPostGrado, ProductoPostGrado, setProductoPostGrado } from "./ProductoPostGradoDTO";
import { ProductoResultado, setListProductoResultado, setProductoResultado } from "./ProductoResultadoDTO";
import { ProductoTerminSolicitanteDTO, setListProductoTerminSolicitante } from "./ProductoTerminSolicitanteDTO";
import { ProductoTerminadoObjOdDTO, getVoidProductoTerminadoObjOdDTO, setProductoTerminadoObjOdDTO } from "./ProductoTerminadoObjOdDTO";
import { ProyectoRelacionado, setListProyectoRelacionado } from "./ProyectoRelacionado";
import { TblDecInvMotivoProdTermin, getVoidMotivo, setProductoMotivo } from "./TblDecInvMotivoProdTermin";
import { TblProductoProdTermin, getVoidProdcutoTerminado, setProductoTerminado } from "./TblProductoProdTermin";

export interface ProductoTerminadoDTO{
    producto: TblProductoProdTermin, 
    colProducto: Array<ProductoColaboradorDTO>,
    solicitantes: Array<ProductoTerminSolicitanteDTO>,
    motivo: TblDecInvMotivoProdTermin,    
    areaConocimiento: ProductoAreaConocimientoDTO,
	lineaInvestigacion: ProductoLineaInvestigacionDTO,
    ods: ProductoTerminadoObjOdDTO,
    areaImplementacion: ProductoAreaImplementacion,
    institucion: ProductoInstitucionPais,
    objEspecificos:Array<ProductoObjEspecifico>
    postgrados: ProductoPostGrado,
    resultados: Array<ProductoResultado>,  
    archivosProd: Array<ProductoArchivo>,
    proyectorel: Array<ProyectoRelacionado>,
    factorImpacto: Array<ProductoFactorImpacto>,
    adjuntos: Array<FileModel>,
    idpersona: number,
    idCategoriaProducto: number,
    eid?: string,
    memoriaListadaGoogleMetrics: string,
    googleMetrics: TDecInvProductoScholarMetric,
    ultimocambio: string,
}

export function getVoidProdcutoTerminadoDTO(): ProductoTerminadoDTO{
    return{
        producto: getVoidProdcutoTerminado(), 
        colProducto: [],
        solicitantes: [],
        motivo: getVoidMotivo(),
        areaConocimiento: getVoidProductoAreaConocimientoDTO(),
        lineaInvestigacion: getVoidProductoLineaInvestigacionDTO(),
        ods: getVoidProductoTerminadoObjOdDTO(),
        areaImplementacion: GetVoidAreaImplementacion(),
        institucion: getVoidProductoInstitucionPais(),
        objEspecificos:[],
        postgrados: GetVoidProductoPostGrado(),
        resultados: [],
        archivosProd: [],      
        proyectorel: [],
        factorImpacto: [],
        adjuntos: [],
        idpersona: 0,
        idCategoriaProducto: 0,
        memoriaListadaGoogleMetrics: 'N',
        googleMetrics: GetVoidTDecInvProductoScholarMetric(),
        eid: "",
        ultimocambio: "",
    }
}

export function setProductoTerminadoDTO(data: any,idpersona: number): ProductoTerminadoDTO{
    return{
        producto: setProductoTerminado(data.producto) as TblProductoProdTermin,
        motivo: setProductoMotivo(data.motivo) as TblDecInvMotivoProdTermin,
        areaConocimiento: setProductoAreaConocimientoDTO(data.areaConocimiento) as ProductoAreaConocimientoDTO,
        colProducto: setListProductoColaborador(data.colProducto) as Array<ProductoColaboradorDTO>,
        solicitantes: setListProductoTerminSolicitante(data.solicitantes) as Array<ProductoTerminSolicitanteDTO>,
        lineaInvestigacion: setProductoLineaInvestigacionDTO(data.lineaInvestigacion) as ProductoLineaInvestigacionDTO,
        ods: setProductoTerminadoObjOdDTO(data.ods) as ProductoTerminadoObjOdDTO,
        areaImplementacion: setAreaImplementacion(data.areaImplementacion) as ProductoAreaImplementacion, 
        institucion: setProductoInstitucionPais(data.institucion),
        objEspecificos: setListProductoEspecifico(data.objEspecificos),
        postgrados: setProductoPostGrado(data.postgrados),
        resultados: setListProductoResultado(data.resultados),
        archivosProd: setListProductoArchivo(data.archivosProd),        
        proyectorel: setListProyectoRelacionado(data.proyectorel),
        factorImpacto: SetListProductoFactorImpacto(data.factorImpacto)??[],
        googleMetrics: SetTDecInvProductoScholarMetric(data.googleMetrics),
        memoriaListadaGoogleMetrics: data.memoriaListadaGoogleMetrics,
        adjuntos: [],
        idpersona: idpersona,
        idCategoriaProducto: data.idCategoriaProducto as number,
        ultimocambio: "",
    }
}

export function FormTypeHandle(id:number,name: string): boolean{
    let flat = true;
    switch(id){
        case 7://Libro/Capitulo de libro ANTIGUO
            let campos7 = ['anio','fechapublicacion','editorial','volumen','paginas','url','bdrevista','codISSN','doi','revisionpares'];
            flat = campos7.includes(name);
            break;
        case 17://Infraestructura/Laboratorio antiguo
            let campos17 = ['idunidad','tipolab','nevento','levento','resumen'];
            flat = campos17.includes(name);
            break;
        case 12://Infraestructura/Equipamento antiguo
            let campos12 = ['idunidad','levento','fevento','marca','modelo','serie','fechapublicacion','fevento','inventario','estado','isindex','frecuencia','asistObjetiv','especificacion'];
            flat = campos12.includes(name);
            break;
        case 24://ARTÍCULO CIENTÍFICO (SCOPUS/WOS)
            let campos = ['anio','url','doi','fechapublicacion','bdrevista','nombreRevista','codISSN','urlRevista','impactoIndex','impactoSJR','cuartil','volumen','paginas','palabrasClave','resumen','iddecinvareaconocimiento','lineainvestigacion','codarea','codsubarea','codsubareadetallada','adjunto'];
            flat = campos.includes(name);
            break;
        case 25://ARTÍCULO CIENTÍFICO (OTRAS INDEXACIONES)
            let campos26 = ['anio','url','doi','fechapublicacion','bdrevista','nombreRevista','codISSN','urlRevista','volumen','paginas','palabrasClave','resumen','iddecinvareaconocimiento','lineainvestigacion','codarea','codsubarea','codsubareadetallada','adjunto'];
            flat = campos26.includes(name);
            break;
        case 26://ARTÍCULO CIENTÍFICO (SIN INDEXACIÓN)
            let campos25 = ['anio','url','doi','fechapublicacion','nombreRevista','codISSN','revisionpares','volumen','paginas','palabrasClave','resumen','adjunto','adjunto2'];
            flat = campos25.includes(name);
            break;
        case 27://ARTÍCULO DE DIVULGACIÓN CIENTÍFICA
            let campos27 = ['anio','url','doi','fechapublicacion','nombreRevista','codISSN','palabrasClave','resumen','adjunto'];
            flat = campos27.includes(name);
            break;
        case 28://Libro/Capitulo de libro
            let campos28 = ['anio','fechapublicacion','editorial','volumen','paginas','url','bdrevista','codISSN','doi','revisionpares','adjunto','adjunto2','adjunto3'];
            flat = campos28.includes(name);
            break;
        case 29://TESIS MAESTRÍA DE INVESTIGACIÓN
            let campos29 = ['url','fevento','palabrasClave','objGeneral','objEspecificos','programaPostgrado','resumen','adjunto','adjunto2'];
            flat = campos29.includes(name);
            break;
        case 30://TESIS DE DOCTORADO
            let campos30 = ['url','fevento','palabrasClave','objGeneral','objEspecificos','programaPostgrado','resumen','adjunto','adjunto2'];
            flat = campos30.includes(name);
            break;
        case 31://ABSTRACT CONFERENCIA
            let campos31 = ['url','nombreRevista','codISSN','nevento','levento','fevento','palabrasClave','adjunto','adjunto2'];
            flat = campos31.includes(name);
            break;
        case 32://Solicitud de Patente
            let campos32 = ['solicitantes','numsolicitud','subclase','proyectorel','casillaMateriaInt','casillaPais','idpais','instTitular','nevento','fechapublicacion','fevento','iddecinvobjods','iddecinvareaconocimiento','lineainvestigacion','codarea','codsubarea','codsubareadetallada','resumen','palabrasClave','adjunto','adjunto2','adjunto3','adjunto4', 'adjunto5'];
            flat = campos32.includes(name);
            break;
        case 33://Derecho de Autor
            let campos33 = ['solicitantes','numsolicitud','iddecinvobjods','subclase','casillaMateriaInt','fevento','especificacion','adjunto','adjunto2'];
            flat = campos33.includes(name);
            break;
        case 34://NUEVA OBTENCION VEGETAL
            let campos34 = ['solicitantes','numsolicitud','proyectorel','casillaPais','idpais','instTitular','nevento','fechapublicacion','fevento','iddecinvobjods','iddecinvareaconocimiento','lineainvestigacion','codarea','codsubarea','codsubareadetallada','resumen','palabrasClave','adjunto','adjunto2'];
            flat = campos34.includes(name);
            break;
        case 35://CASO ESTUDIO
            let campos35 = ['url','fechapublicacion','nombreRevista','objEspecificos','resultados','resumen','especificacion','adjunto','adjunto2'];
            flat = campos35.includes(name);
            break;
        case 36://POSTER CONFERENCIA
            let campos36 = ['nombreRevista','nevento','levento','fevento','adjunto','adjunto2'];
            flat = campos36.includes(name);
            break;
        case 37://Infraestructura/Equipamento
            let campos37 = ['idunidad','levento','marca','modelo','serie','fechapublicacion','fevento','inventario','estado','isindex','frecuencia','especificacion','adjunto'];
            flat = campos37.includes(name);
            break;
        case 38://Infraestructura/Laboratorio
            let campos38 = ['idunidad','tipolab','nevento','levento','resumen','adjunto'];
            flat = campos38.includes(name);
            break;
        case 39://Organización y ejecución de Taller/Curso/Conferencia
            let campos39 = ['nevento','especificacion','levento','fevento','adjunto','adjunto2','adjunto3'];
            flat = campos39.includes(name);
            break;    
        case 40://Metodología/Protocolo implementado
            let campos40 = ['codigoproducto','especificacion','areaimplementacion','adjunto','adjunto2','adjunto3','adjunto4','adjunto5'];
            flat = campos40.includes(name);
            break;
        case 41://Proyecto de titulación de Grado
            let campos41 = ['url','palabrasClave','objGeneral','objEspecificos','resumen','fevento','adjunto'];
            flat = campos41.includes(name);
            break;
        case 42://Proyecto de titulación de maestría profesional
            let campos42 = ['url','palabrasClave','objGeneral','objEspecificos','programaPostgrado','resumen','fevento','adjunto','adjunto2'];
            flat = campos42.includes(name);
            break;
        case 43://Participación en conferencia
            let campos43 = ['nombreRevista','nevento','levento','fevento','adjunto'];
            flat = campos43.includes(name);
            break;
        case 44://Secreto Empresarial o información no divulgada
            let campos44 = ['casillaMateriaInt','iddecinvobjods','iddecinvareaconocimiento','lineainvestigacion','codarea','codsubarea','codsubareadetallada','fevento','adjunto','adjunto2'];
            flat = campos44.includes(name);
            break;
        case 45://Informes técnicos de resultados de investigación (Arqueología)
            let campos45 = ['solicitantes','subclase','paginas','palabrasClave','resumen','iddecinvareaconocimiento','lineainvestigacion','codarea','codsubarea','codsubareadetallada','anio','adjunto','adjunto2','adjunto3'];
            flat = campos45.includes(name);
            break;
        case 46://ARTÍCULO DE CONFERENCIA (SCOPUS/WOS)
            let campos46 = ['anio','url','doi','fechapublicacion','bdrevista','nombreRevista','codISSN','urlRevista','impactoIndex','impactoSJR','cuartil','volumen','paginas','palabrasClave','resumen','iddecinvareaconocimiento','lineainvestigacion','codarea','codsubarea','codsubareadetallada','adjunto','adjunto2','adjunto3'];
            flat = campos46.includes(name);
            break;
        case 47://PRODUCTO TRANSICION
            let campos47 = ['anio','url','doi','subclase','adjunto','adjunto2','adjunto3','adjunto4'];
            flat = campos47.includes(name);
            break;
        default:
            flat = false;
            break;
    }
    return flat;
}

export function FormSubClassHandle(id:number,name: string): boolean{
    let flat = true;
    switch(id){
        case 3830://Planta transgenica
            let campos1 = ['fechapublicacion','asistObjetiv','innovaVerific','logrosSistemac','retosComunic'];
            flat = campos1.includes(name);
            break;
        case 3831://Prototipo
            let campos2 = ['fechapublicacion','palabrasClave','resumen','logrosSistemac'];
            flat = campos2.includes(name);
            break;
        case 3832://Secuencia sintética
            let campos3 = ['objGeneral'];
            flat = campos3.includes(name);
            break;
        case 3833://Software
            let campos4 = ['especificacion'];
            flat = campos4.includes(name);
            break;
        case 3834://Vacuna
            let campos5 = ['fechapublicacion','palabrasClave','resumen','logrosSistemac'];
            flat = campos5.includes(name);
            break;
        case 3835://Transferencia tecnologia
            let campos6 = ['idunidad','resumen','asistObjetiv'];
            flat = campos6.includes(name);
            break;
        default:
            flat = false;
            break;
    }
    return flat;
}

export function FormLabelHandle(id:number,name: string): string{
    let label = "";
    switch(id){
        case 0:
            switch(name){
                case 'codISSN':
                    label = 'Código ISSN de la Revista: '
                    break;
                case 'nevento':
                    label = 'Nombre Evento: '
                    break;
                case 'levento':
                    label = 'Lugar Evento: '
                    break;
                case 'fevento':
                    label = 'Fecha Evento: '
                    break;                        
                case 'palabrasClave':
                    label = 'Palabras Claves: '
                    break;
                case 'resumen':
                    label = 'Resumen: '
                    break;
                case 'idunidad':
                    label = 'Unidad: '
                    break;
                case 'tipolab':
                    label = 'Tipo Laboratorio: '
                    break;
                case 'fechapublicacion':
                    label = 'Fecha Publicación: '
                    break;
                case 'editorial':
                    label = 'Editorial: '
                    break;
                default:
                    label = name;
                    break;
            }                
        break;
        case 17://Infraestructura/Laboratorio antiguo
            switch(name){
                case 'nevento':
                    label = 'Nombre Laboratorio: '
                    break;
                case 'levento':
                    label = 'Ubicación: '
                    break;
                case 'tipolab':
                    label = 'Tipo de Laboratorio: '
                    break;                         
                case 'palabrasClave':
                        label = 'Responsable: '
                        break;
                case 'resumen':
                    label = 'Áreas del Laboratorio: '
                    break;
                case 'idunidad':
                    label = 'Unidad: '
                    break;
                default:
                    label = name;
                    break;
            }                
            break;
        case 12://Infraestructura/Equipamento antiguo
            switch(name){
                case 'nevento':
                    label = 'Nombre Laboratorio: '
                    break;
                case 'levento':
                    label = 'Ubicación: '
                    break;
                case 'fevento':
                    label = 'Último Mantenimiento - Obligatorio solo si escoge la opción de "USADO": '
                    break;
                case 'marca':
                    label = 'Marca: '
                    break;
                case 'modelo':
                    label = 'Modelo: '
                    break;
                case 'serie':
                    label = 'Número de Serie (ID): '
                    break;
                case 'invetario':
                    label = 'Número Inventario de ESPOL/ESPOLTECH: '
                    break;
                case 'fechapublicacion':
                    label = 'Fecha de Compra - Obligatorio solo si escoge la opción de "NUEVO": '
                    break;
                case 'palabrasClave':
                        label = 'Responsable: '
                        break;
                case 'resumen':
                    label = 'Áreas del Laboratorio: '
                    break;
                case 'idunidad':
                    label = 'Unidad: '
                    break;
                case 'isindex':
                    label = 'Condiciones de Brindar Servicio: '
                    break;
                default:
                    label = name;
                    break;
            }                
            break;
        case 24://ARTÍCULO CIENTÍFICO (SCOPUS/WOS)
            switch(name){
                case 'adjunto':
                    label = '*Adjuntar PDF del Artículo científico'
                    break;
                case 'adjunto2':
                    label='Certificado de asistencia a conferencia';
                    break;
                case 'adjunto3':
                    label='Adjuntar diapositivas (En caso de que aplique)';
                    break;
                case 'codISSN':
                    label = 'Código ISSN de la Revista: '
                    break;
                case 'cuartil':
                    label = '*Cuartil';
                    break;
                case 'impactoIndex':
                    label = '*Factor Impacto: ';
                    break;
                case 'impactoSJR':
                    label = '*Factor Impacto: ';
                    break;
                case 'impactoSciScore':
                    label = '*Factor Impacto: ';
                    break;
                case 'cuartilCiteScore':
                    label = '*Cuartil';
                    break;
                case 'esPrimerDecilCiteScore':
                    label = '¿Es Primer Decil?';
                    break;
                case "doi":
                    label = "*DOI: ";
                    break;
                case 'nevento':
                    label = 'Nombre Evento: '
                    break;
                case 'levento':
                    label = 'Lugar Evento: '
                    break;
                case 'fevento':
                    label = 'Fecha Evento: '
                    break;                        
                case 'palabrasClave':
                    label = '*Palabras Claves: '
                    break;
                case 'resumen':
                    label = '*Resumen: '
                    break;
                case 'idunidad':
                    label = 'Unidad: '
                    break;
                case "revisionpares":
                    label = "Tiene revisión por pares: ";
                    break;
                case 'tipolab':
                    label = 'Tipo Laboratorio: '
                    break;
                case 'fechapublicacion':
                    label = '*Fecha Publicación: '
                    break;
                case 'editorial':
                    label = 'Editorial: '
                    break;
                case 'nombreRevista':
                    label = '*Nombre de Revista/ Memoria de Evento: '
                    break;
                case 'url':
                    label = '*Url de Publicación: '
                    break;
                case 'urlRevista':
                    label = '*Url de la revista / Memoria de Evento: '
                    break;
                case 'volumen':
                    label = '*Volumen: ';
                    break;
                case 'paginas':
                    label = '*Páginas: ';
                    break;
                case 'especificacion':
                    label = 'Especificación: '
                    break;
                case 'iddecinvobjods':
                    label = 'ODS del producto: '
                    break;
                case 'codarea':
                    label = '*Área CINE/UNESCO: '
                    break;
                case 'codsubarea':
                    label = '*Sub-área CINE/UNESCO: '
                    break;
                case 'codsubareadetallada':
                    label = '*Sub-área detallada CINE/UNESCO: '
                    break;
                case 'anio':
                    label = '*Año de Publicación: ';
                    break;
                case 'iddecinvareaconocimiento':
                    label = '*Área prioritarias de investigación y vinculación: ';
                    break;
                case 'lineainvestigacion':
                    label = '*Línea de investigación y vinculación: ';
                    break;
                case 'bdrevista':
                    label = '*Tipo de indexación';
                    break;
                default:
                    label = name;
                    break;
            } 
            break;
        case 25://ARTÍCULO CIENTÍFICO (OTRAS INDEXACIONES)
            switch(name){
                case 'adjunto':
                    label = '*Adjuntar PDF del Artículo científico'
                    break;
                case 'adjunto2':
                    label='Certificado de asistencia a conferencia';
                    break;
                case 'adjunto3':
                    label='Adjuntar diapositivas (En caso de que aplique)';
                    break;
                case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                case 'cuartil':
                    label = '*Cuartil';
                    break;
                case 'impactoIndex':
                    label = '*Factor Impacto: ';
                    break;
                case 'impactoSJR':
                    label = '*Factor Impacto: ';
                    break;
                case 'cuartilCiteScore':
                    label = '*Cuartil';
                    break;
                case 'esPrimerDecilCiteScore':
                    label = '¿Es Primer Decil?';
                    break;
                case "doi":
                    label = "*DOI: ";
                    break;
                case 'palabrasClave':
                    label = '*Palabras Claves: '
                    break;
                case 'resumen':
                    label = '*Resumen: '
                    break;
                case 'urlRevista':
                    label = '*Url de la revista / Memoria de Evento: '
                    break;
                case "revisionpares":
                    label = "Tiene revisión por pares: ";
                    break;
                case 'volumen':
                    label = '*Volumen: ';
                    break;
                case 'paginas':
                    label = '*Páginas: ';
                    break;
                case 'levento':
                        label = 'Lugar Evento: '
                        break;
                case 'fevento':
                        label = 'Fecha Evento: '
                        break;                        
                case 'idunidad':
                        label = 'Unidad: '
                        break;
                case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                case 'editorial':
                        label = 'Editorial: '
                        break;
                case 'nombreRevista':
                        label = '*Nombre de Revista/ Memoria de Evento: '
                        break;
                case 'urlRevista':
                        label = '*Url de la revista / Memoria de Evento: '
                        break;
                case 'url':
                        label = '*Url de Publicación: '
                        break;
                case 'especificacion':
                        label = 'Especificación: '
                        break;
                case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                case 'codarea':
                        label = '*Área CINE/UNESCO: '
                        break;
                case 'codsubarea':
                        label = '*Sub-área CINE/UNESCO: '
                        break;
                case 'codsubareadetallada':
                        label = '*Sub-área detallada CINE/UNESCO: '
                        break;
                case 'anio':
                        label = '*Año de Publicación: ';
                        break;
                case 'iddecinvareaconocimiento':
                    label = '*Área prioritarias de investigación y vinculación: ';
                    break;
                case 'lineainvestigacion':
                    label = '*Línea de investigación y vinculación: ';
                    break;
                case 'bdrevista':
                    label = '*Tipo de indexación';
                    break;
                default:
                    label = name;
                    break;
            }
        break;
        case 26://ARTÍCULO CIENTÍFICO (SIN INDEXACIÓN)
            switch(name){
                case 'adjunto':
                    label='*Adjuntar PDF del Artículo científico';
                    break;
                case 'adjunto2':
                    label='Adjuntar Prueba de Revisión de Pares - Obligatorio si tuvo revisión por pares';
                    break;
                case 'codISSN':
                    label = '*Código ISSN de la Revista: '
                    break;
                case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                case 'levento':
                        label = 'Lugar Evento: '
                        break;
                case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                case 'cuartil':
                    label = '*Cuartil';
                    break; 
                case "doi":
                    label = "*DOI: ";
                    break;                       
                case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                case 'paginas':
                    label = '*Páginas: ';
                    break;
                case 'resumen':
                        label = '*Resumen: '
                        break;
                case 'idunidad':
                        label = 'Unidad: '
                        break;
                case "revisionpares":
                    label = "Tiene revisión por pares: ";
                    break;
                case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                case 'fechapublicacion':
                        label = '*Fecha Publicación: '
                        break;
                case 'editorial':
                        label = 'Editorial: '
                        break;
                case 'nombreRevista':
                        label = '*Nombre de Revista/ Memoria de Evento: '
                        break;
                case 'url':
                        label = '*Url de Publicación: '
                        break;
                case 'volumen':
                        label = '*Volumen: ';
                        break;
                case 'especificacion':
                        label = 'Especificación: '
                        break;
                case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;  
                default:
                    label = name;
                    break;
            }

        break;
        case 27://ARTÍCULO DE DIVULGACIÓN CIENTÍFICA
            switch(name){
                case 'adjunto':
                    label='*Adjuntar PDF del Artículo de divulgación científica';
                    break;
                case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                case "doi":
                    label = "*DOI: ";
                    break;
                case "revisionpares":
                    label = "Tiene revisión por pares: ";
                    break;
                case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                case 'levento':
                        label = 'Lugar Evento: '
                        break;
                case 'fevento':
                        label = 'Fecha Evento: '
                        break;                        
                case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                case 'resumen':
                        label = 'Resumen: '
                        break;
                case 'idunidad':
                        label = 'Unidad: '
                        break;
                case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                case 'fechapublicacion':
                        label = '*Fecha Publicación: '
                        break;
                case 'editorial':
                        label = 'Editorial: '
                        break;
                case 'nombreRevista':
                        label = '*Nombre de Revista/ Memoria de Evento: '
                        break;
                case 'url':
                        label = '*Url de Publicación: '
                        break;
                case 'especificacion':
                        label = 'Especificación: '
                        break;
                case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                case 'anio':
                        label = '*Año de Publicación: ';
                        break;
                case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                default:
                    label=name;
                    break;
            }
        break;
        case 28://Libro/Capitulo de libro
            switch(name){
                case 'adjunto':
                    label = '*Adjuntar PDF del libro o capítulo de libro';
                    break;
                case 'adjunto2':                        
                    label = '*Adjuntar Prueba de Revisión de Pares - Obligatorio si se coloca SI en revisión por pares';
                    break;
                case 'adjunto3':
                    label = 'Adjuntar Notificación de Aceptación(En caso de que exista)';
                    break;
                case 'codISSN':
                    label = '*Código Normalización (ISBN/ISSN): '
                    break;
                case 'editorial':
                    label = '*Editorial: '
                    break;
                case 'fechapublicacion':
                    label = '*Fecha Publicación: '
                    break;
                case 'url':
                    label = '*Url de Publicación: '
                    break;
                case 'anio':
                    label = 'Año de Publicación: ';
                    break;
                case 'paginas':
                    label = '*Páginas: ';
                    break;
                case 'bdrevista':
                    label = '*Tipo de indexación';
                    break;
                case "doi":
                    label = "DOI: ";
                    break;
                case "revisionpares":
                    label = "*Tuvo Revisión por Pares (SI/NO): ";
                    break;
                case 'volumen':
                    label = '*Volumen: ';
                    break;
                default:
                    label=name;
                    break;
            }
        break;
        case 29://TESIS MAESTRÍA DE INVESTIGACIÓN
            switch(name){
                case 'resumen':
                    label = '*Resumen: '
                    break;
                case 'fevento':
                    label = '*Fecha de titulación: '
                    break;
                case 'palabrasClave':
                    label = '*Palabras claves: '
                    break;
                case 'url':
                    label = 'Url de Publicación: '
                    break;
                case 'idprograma':
                    label = '*Nombre del programa de postgrado: '
                    break;
                case 'nombreprograma':
                    label = '*Nombre del programa de postgrado: '
                    break;
                case 'instituciontitularPG':
                    label = '*Institución titular del programa de posgrado: '
                    break;
                case 'adjunto':
                    label = '*Adjuntar PDF de tesis'
                    break;
                case 'adjunto2':
                    label = '*Diploma o certificado de titulación'
                    break;
                case 'objGeneral':
                    label = '*Objetivo General: '
                    break;
                case 'objEspecificos':
                    label = 'Objetivos Especificos';
                    break;
                default:
                    label = name;
                    break;
            }                
            break;
        case 30://TESIS DE DOCTORADO
            switch(name){
                case 'resumen':
                    label = '*Resumen: '
                    break;
                case 'fevento':
                    label = 'Fecha de titulación: '
                    break;
                case 'palabrasClave':
                    label = '*Palabras claves: '
                    break;
                case 'url':
                    label = 'Url de Publicación: '
                    break;
                case 'objGeneral':
                    label = '*Objetivo General: '
                    break;
                case 'objEspecificos':
                    label = 'Objetivos Especificos';
                    break;
                case 'idprograma':
                    label = '*Nombre del programa de postgrado: '
                    break;
                case 'nombreprograma':
                    label = '*Nombre del programa de postgrado: '
                    break;
                case 'instituciontitularPG':
                    label = '*Institución titular del programa de posgrado: '
                    break;
                case 'adjunto':
                    label = '*Adjuntar PDF de tesis'
                    break;
                case 'adjunto2':
                    label = '*Diploma o certificado de titulación'
                    break;
                default:
                    label = name;
                    break;
            }                
            break;
        case 31://ABSTRACT CONFERENCIA
            switch(name){
                case 'nombreRevista':
                    label = '*Organizadores de la conferencia: '
                    break;
                case 'codISSN':
                    label = '*Código ISSN / ISBN de las memorias de conferencia: '
                    break;
                case 'nevento':
                    label = '*Nombre de conferencia: '
                    break;
                case 'levento':
                    label = '*Lugar del evento: '
                    break;
                case 'fevento':
                    label = '*Fecha del evento: '
                    break;
                case 'palabrasClave':
                        label = '*Palabras claves: '
                        break;
                case 'url':
                    label = 'Url de Publicación: '
                    break;
                case 'adjunto':
                    label = '*Adjuntar el Abstract presentado en la conferencia'
                    break;
                case 'adjunto2':
                    label = '*Adjuntar el certificado de participación en la conferencia'
                    break;                        
                default:
                    label = name;
                    break;
            }                
            break;
        case 32://Solicitud de Patente
            switch(name){
                case 'adjunto':
                    label='*Adjuntar Figuras';
                    break;
                case 'adjunto2':
                    label='*Adjuntar Descripción';
                    break;
                case 'adjunto3':
                    label='*Adjuntar Solicitud de ingreso de Patente';
                    break;                    
                case 'adjunto4':
                    label='*Adjuntar Notificación de ingreso de Patente';
                    break;
                case 'adjunto5':                        
                    label='Adjuntar PDF de la Patente';
                    break;
                case 'solicitantes':
                    label='*Solicitantes o titulares (nombre de institución / persona, porcentaje de titularidad): ';
                    break; 
                case 'subclase':
                    label='*Tipo de patente: ';
                    break; 
                case 'numsolicitud':
                    label='Número de Solicitud: ';
                    break;
                case 'proyectorel':
                    label='Proyectos relacionados: ';
                    break;
                case 'casillaMateriaInt':
                    label='Si proviene de Materia integradora';
                    break;
                case 'casillaPais':
                    label= 'Si proviene de otro país';
                    break; 
                case 'idpais':
                    label= 'País';
                    break; 
                case 'instTitular':
                    label= '*Institución que realiza la solicitud: ';
                    break; 
                case 'codISSN':
                    label = 'Código ISSN de la Revista: '
                    break;
                case 'nevento':
                    label = '*Ente/Organismo competente: '
                    break;
                case 'levento':
                    label = 'Lugar Evento: '
                    break;
                case 'fechapublicacion':
                    label = '*Fecha de presentación a la Oficina Institucional de PI: '
                    break;
                case 'fevento':
                    label = '*Fecha de presentación al Ente / Organismo competente: '
                    break;                        
                case 'palabrasClave':
                    label = '*Palabras Claves: '
                    break;
                case 'resumen':
                    label = '*Resumen técnico: '
                    break;
                case 'idunidad':
                    label = 'Unidad: '
                    break;
                case 'tipolab':
                    label = 'Tipo Laboratorio: '
                    break;
                case 'editorial':
                    label = 'Editorial: '
                    break;
                case 'nombreRevista':
                    label = 'Nombre de Revista/ Memoria de Evento: '
                    break;
                case 'url':
                    label = 'Url de Publicación: '
                    break;
                case 'especificacion':
                    label = 'Especificación: '
                    break;
                case 'iddecinvobjods':
                    label = '*ODS al que contribuye el producto: '
                    break;
                case 'codarea':
                    label = '*Área CINE/UNESCO: '
                    break;
                case 'codsubarea':
                    label = '*Sub-área CINE/UNESCO: '
                    break;
                case 'codsubareadetallada':
                    label = '*Sub-área detallada CINE/UNESCO: '
                    break;
                case 'anio':
                    label = 'Año de Publicación: ';
                    break;
                case 'iddecinvareaconocimiento':
                    label = '*Área prioritarias de investigación y vinculación: ';
                    break;
                case 'lineainvestigacion':
                    label = '*Línea de investigación y vinculación: ';
                    break;                                              
                default:
                    label=name;
                    break;
            }
            break;
        case 33://Derecho de Autor
            switch(name){
                case 'adjunto':
                    label='*Registro de derecho de autor'
                    break;
                case 'adjunto2':
                    label='*Aduntar Notificación de registro'
                    break;
                case 'casillaMateriaInt':
                    label='Si proviene de Materia integradora';
                    break;
                case 'subclase':
                    label='Clase de obra: ';
                    break;
                case 'solicitantes':
                    label='*Titulares (nombre de institución / persona, porcentaje de titularidad): ';
                    break; 
                case 'numsolicitud':
                    label='*N° certificado: ';
                    break;  
                case 'codISSN':
                    label = 'Código ISSN de la Revista: '
                    break;
                case 'nevento':
                    label = 'Nombre Evento: '
                    break;
                case 'levento':
                    label = 'Lugar Evento: '
                    break;
                case 'fevento':
                    label = '*Fecha de registro: '
                    break;                        
                case 'palabrasClave':
                    label = 'Palabras Claves: '
                    break;
                case 'resumen':
                    label = 'Resumen: '
                    break;
                case 'idunidad':
                    label = 'Unidad: '
                    break;
                case 'tipolab':
                    label = 'Tipo Laboratorio: '
                    break;
                case 'fechapublicacion':
                    label = 'Fecha Publicación: '
                    break;
                case 'editorial':
                    label = 'Editorial: '
                    break;
                case 'nombreRevista':
                    label = 'Nombre de Revista/ Memoria de Evento: '
                    break;
                case 'url':
                    label = 'Url de Publicación: '
                    break;
                case 'especificacion':
                    label = '*Especificación: '
                    break;
                case 'iddecinvobjods':
                    label = '*ODS del producto: '
                    break;
                case 'codarea':
                    label = 'Área CINE/UNESCO: '
                    break;
                case 'codsubarea':
                    label = 'Sub-área CINE/UNESCO: '
                    break;
                case 'codsubareadetallada':
                    label = 'Sub-área detallada CINE/UNESCO: '
                    break;
                case 'anio':
                    label = 'Año de Publicación: ';
                    break;
                case 'iddecinvareaconocimiento':
                    label = 'Área de investigación: ';
                    break;
                case 'lineainvestigacion':
                    label = 'Línea de investigación: ';
                    break;
                }
            break;
        case 34://NUEVA OBTENCION VEGETAL
            switch(name){
                case 'adjunto':
                    label='*Adjuntar Solicitud de ingreso de Derecho Obtentor'
                    break;
                case 'adjunto2':
                    label='*Adjuntar Notificación de ingreso de Derecho Obtentor'
                    break;
                case 'solicitantes':
                    label='*Solicitantes o titulares (nombre de institución / persona, porcentaje de titularidad): ';
                    break; 
                case 'subclase':
                    label='Tipo de patente: ';
                    break; 
                case 'numsolicitud':
                    label='*Número de Solicitud: ';
                    break;
                case 'proyectorel':
                    label='Proyectos relacionados: ';
                    break;
                case 'casillaMateriaInt':
                    label='Si proviene de Materia integradora';
                    break; 
                case 'casillaPais':
                    label= 'Si proviene de otro país';
                    break; 
                case 'idpais':
                    label= 'País';
                    break; 
                case 'instTitular':
                    label= '*Institución que realiza la solicitud: ';
                    break;  
                case 'codISSN':
                    label = 'Código ISSN de la Revista: '
                    break;
                case 'nevento':
                    label = '*Ente / Organismo competente: '
                    break;
                case 'levento':
                    label = 'Lugar Evento: '
                    break;
                case 'fevento':
                    label = '*Fecha de presentación al Ente / Organismo competente: '
                    break;                        
                case 'palabrasClave':
                    label = '*Palabras Claves: '
                    break;
                case 'paginas':
                    label = '*Páginas: ';
                    break;
                case 'resumen':
                    label = '*Resumen Técnico: '
                    break;
                case 'idunidad':
                    label = 'Unidad: '
                    break;
                case 'tipolab':
                    label = 'Tipo Laboratorio: '
                    break;
                case 'fechapublicacion':
                    label = '*Fecha de presentación a la Oficina Institucional de PI: '
                    break;
                case 'editorial':
                    label = 'Editorial: '
                    break;
                case 'nombreRevista':
                    label = 'Nombre de Revista/ Memoria de Evento: '
                    break;
                case 'url':
                    label = 'Url de Publicación: '
                    break;
                case 'especificacion':
                    label = 'Especificación: '
                    break;
                case 'iddecinvobjods':
                    label = '*ODS del producto: '
                    break;
                case 'codarea':
                    label = '*Área CINE/UNESCO: '
                    break;
                case 'codsubarea':
                    label = '*Sub-área CINE/UNESCO: '
                    break;
                case 'codsubareadetallada':
                    label = '*Sub-área detallada CINE/UNESCO: '
                    break;
                case 'anio':
                    label = 'Año de Publicación: ';
                    break;
                case 'iddecinvareaconocimiento':
                    label = '*Área prioritarias de investigación y vinculación: ';
                    break;
                case 'lineainvestigacion':
                    label = '*Línea de investigación y vinculación: ';
                    break;
                default:
                    label=name;
                    break;
                }
            break;
        case 35://caso Estudio
            switch(name){
                case 'fechapublicacion':
                    label = 'Fecha Publicación: '
                    break;
                case 'url':
                    label = 'Url de Publicación: '
                    break;
                case 'resumen':
                    label = '*Resumen: '
                    break;
                case 'nombreRevista':
                    label = '*Nombre de revista: '
                    break;
                case 'especificacion':
                    label = '*Metodología: '
                    break;
                case 'logrosSistemac':
                    label = 'Sistematicidad: ';
                    break;
                case 'retosComunic':
                    label = 'Comunicabilidad: ';
                    break;
                case 'objEspecificos':
                    label = 'Objetivos ';
                    break;
                case 'resultados':
                    label = 'Resultados';
                    break;                        
                case 'adjunto':
                    label='Adjuntar PDF del caso de estudio';
                    break;
                case 'adjunto2':
                    label='Adjuntar Otra Evidencia'
                    break;
                default:
                    label = name;
                    break;
            }                
            break;
        case 36://POSTER CONFERENCIA
            switch(name){
                case 'nombreRevista':
                    label = '*Organizadores de la conferencia: '
                    break;
                case 'nevento':
                    label = '*Nombre de conferencia: '
                    break;
                case 'levento':
                    label = '*Lugar del evento: '
                    break;
                case 'fevento':
                    label = '*Fecha del evento: '
                    break;
                case 'adjunto':
                    label='*Adjuntar póster de la conferencia';
                    break;
                case 'adjunto2':
                    label = '*Adjuntar certificado de participación';
                    break;
                default:
                    label = name;
                    break;
            }                
            break;
        case 37://Infraestructura/Equipamento
            switch(name){
                case 'nevento':
                    label = 'Nombre Laboratorio: '
                    break;
                case 'levento':
                    label = '*Área / Laboratorio: '
                    break;
                case 'fevento':
                    label = '*Último Mantenimiento - Obligatorio solo si escoge la opción de "USADO": '
                    break;
                case 'marca':
                    label = '*Marca: '
                    break;
                case 'modelo':
                    label = '*Modelo: '
                    break;
                case 'serie':
                    label = '*Número de Serie (ID): '
                    break;
                case 'inventario':
                    label = '*Número Inventario de ESPOL/ESPOLTECH: '
                    break;
                case 'estado':
                    label = '*Estado: '
                    break;  
                case 'frecuencia':
                    label = '*Frecuencia de USO: '
                    break;
                case 'asistObjetiv':
                    label = 'Usuarios: '
                    break;   
                case 'fechapublicacion':
                    label = '*Fecha de Compra - Obligatorio solo si escoge la opción de "NUEVO": '
                    break;
                case 'palabrasClave':
                        label = 'Responsable: '
                        break;
                case 'especificacion':
                    label = '*Especificación Técnica: '
                    break;
                case 'idunidad':
                    label = '*Unidad: '
                    break;
                case 'isindex':
                    label = '*Condiciones de Brindar Servicio: '
                    break;
                case 'adjunto':
                    label='*Adjuntar Ficha técnica del Equipo';
                    break;
                default:
                    label = name;
                    break;
            }                
            break;
        case 38://Infraestructura/Laboratorio
            switch(name){
                case 'nevento':
                    label = '*Nombre Laboratorio: '
                    break;
                case 'levento':
                    label = '*Ubicación: '
                    break;
                case 'tipolab':
                    label = '*Tipo de Laboratorio: '
                    break;                         
                case 'palabrasClave':
                    label = 'Responsable: '
                    break;
                case 'resumen':
                    label = '*Áreas del Laboratorio: '
                    break;
                case 'idunidad':
                    label = '*Unidad: '
                    break;
                case 'adjunto':
                    label = '*Informe de creación de laboratorio (imágenes)';
                    break;
                default:
                    label = name;
                    break;
            }                
            break; 
        case 39://Organización y ejecución de Taller/Curso/Conferencia
            switch(name){
                case 'nevento':
                    label = '*Temática: '
                    break;
                case 'levento':
                    label = '*Lugar: '
                    break;
                case 'fevento':
                    label = '*Fecha: '
                    break;
                case 'asistObjetiv':
                    label = 'Asistentes: '
                    break; 
                case 'especificacion':
                    label = '*Requisitos: '
                    break;
                case 'adjunto':
                    label = '*Presentación del taller';
                    break;
                case 'adjunto2':
                    label = '*Listado de asistencia';
                    break;
                case 'adjunto3':
                    label = 'Adjuntar Otro tipo de Evidencia';
                    break;
                default:
                    label = name;
                    break;
            }                
            break;
        case 40://Metodología/Protocolo implementado
            switch(name){
                case 'codigoproducto':
                    label = '*Código: '
                    break;
                case 'especificacion':
                    label = '*Especificaciones: '
                    break;
                case 'areaimplementacion':
                    label = '*Área de Implementación: ';
                    break;
                case 'adjunto':
                    label='*Adjuntar PDF del Producto';
                    break;
                case 'adjunto2':
                    label='Adjuntar Notificación de Aceptación(En caso de que exista)';
                    break;
                case 'adjunto3':
                    label='Adjuntar Prueba de Revisión de Pares(En caso de ser requerido)';
                    break;
                case 'adjunto4':
                    label='Adjuntar Otro tipo de Evidencia';
                    break;
                case 'adjunto5':
                    label='Adjuntar Planes de manejo y conservación';
                    break;                        
                default:
                    label = name;
                    break;
            }                
            break;
        case 41://Proyecto de titulación grado
            switch(name){
                case 'fevento':
                    label = '*Fecha de Titulación: '
                    break;                        
                case 'palabrasClave':
                    label = '*Palabras Claves: '
                    break;
                case 'objGeneral':
                    label = '*Objetivo General: '
                    break;
                case 'objEspecificos':
                    label = '*Objetivos Especificos';
                    break;                    
                case 'resumen':
                    label = '*Resumen: '
                    break;
                case 'url':
                    label = 'Url de Publicación: '
                    break;
                case 'adjunto':
                    label = '*Proyecto integrador (Registrado en CIB)'
                    break;
                case 'adjunto2':
                    label = '*Diploma o certificado de titulación'
                    break;
                default:
                    label = name;
                    break;
                }
            break;
        case 42://Proyecto de titulación de maestría profesional
            switch(name){
                case 'fevento':
                    label = 'Fecha de Titulación: '
                    break;                        
                case 'palabrasClave':
                    label = 'Palabras Claves: '
                    break;
                case 'objGeneral':
                    label = '*Objetivo General: '
                    break;
                case 'objEspecificos':
                    label = 'Objetivos Especificos';
                    break;                       
                case 'resumen':
                    label = 'Resumen: '
                    break;
                case 'url':
                    label = 'Url de Publicación: '
                    break;
                case 'idprograma':
                    label = '*Nombre del programa de postgrado: '
                    break;
                case 'nombreprograma':
                    label = '*Nombre del programa de postgrado: '
                    break;
                case 'instituciontitularPG':
                    label = '*Institución titular del programa de posgrado: '
                    break;
                case 'adjunto':
                    label='*Adjuntar PDF de tesis';
                    break;
                case 'adjunto2':
                    label='*Diploma o certificado de titulación';
                break;
                default:
                    label = name;
                    break;
            }                
            break;
        case 43://Participación en conferencia
            switch(name){
                case 'nombreRevista':
                    label = 'Organizadores de la conferencia: '
                    break;
                case 'nevento':
                    label = 'Nombre de conferencia: '
                    break;
                case 'levento':
                    label = 'Lugar del evento: '
                    break;
                case 'fevento':
                    label = 'Fecha del evento: '
                    break;
                case 'adjunto':
                    label='*Adjuntar certificado de participación';
                    break;
                default:
                    label = name;
                    break;
            }                
            break;
        case 44://Secreto Empresarial o información no divulgada
            switch(name){
                case 'adjunto':
                    label = '*Aduntar Notificación de registro'
                    break;
                case 'adjunto2':
                    label='*Registro del depósito de información no divulgada (Secreto)';
                    break;
                case 'codISSN':
                    label = 'Código ISSN de la Revista: '
                    break;
                case 'casillaMateriaInt':
                    label='Si proviene de Materia integradora';
                    break; 
                case 'nevento':
                    label = 'Nombre Evento: '
                    break;
                case 'levento':
                    label = 'Lugar Evento: '
                    break;
                case 'fevento':
                    label = '*Fecha de registro: '
                    break;                        
                case 'palabrasClave':
                    label = 'Palabras Claves: '
                    break;
                case 'resumen':
                    label = 'Resumen: '
                    break;
                case 'idunidad':
                    label = 'Unidad: '
                    break;
                case 'tipolab':
                    label = 'Tipo Laboratorio: '
                    break;
                case 'fechapublicacion':
                    label = 'Fecha Publicación: '
                    break;
                case 'editorial':
                    label = 'Editorial: '
                    break;
                case 'nombreRevista':
                    label = 'Nombre de Revista/ Memoria de Evento: '
                    break;
                case 'url':
                    label = 'Url de Publicación: '
                    break;
                case 'especificacion':
                    label = 'Especificación: '
                    break;
                case 'iddecinvobjods':
                    label = '*ODS del producto: '
                    break;
                case 'codarea':
                    label = '*Área CINE/UNESCO: '
                    break;
                case 'codsubarea':
                    label = '*Sub-área CINE/UNESCO: '
                    break;
                case 'codsubareadetallada':
                    label = '*Sub-área detallada CINE/UNESCO: '
                    break;
                case 'anio':
                    label = 'Año de Publicación: ';
                    break;
                case 'iddecinvareaconocimiento':
                    label = '*Área de investigación: ';
                    break;
                case 'lineainvestigacion':
                    label = '*Línea de investigación: ';
                    break;
                default:
                    label = name;
                    break;
            }
            break;
        case 45://Informes técnicos de resultados de investigación (Arqueología)
            switch(name){
                case 'adjunto':
                    label = '*Adjuntar PDF del Informe aprobado'
                    break;
                case 'adjunto2':
                    label='*Adjuntar evidencia de aprobación del documento';
                    break;
                case 'adjunto3':
                    label='*Adjuntar fichas de inventario';
                    break;
                case 'subclase':
                    label='*Tipo de informe: ';
                    break;
                case 'anio':
                    label='*Año de Publicación: ';
                    break;
                case 'solicitantes':
                    label='*Nombre de Institución externa: ';
                    break;
                case 'codarea':
                    label = '*Área CINE/UNESCO: '
                    break;
                case 'codsubarea':
                    label = '*Sub-área CINE/UNESCO: '
                    break;
                case 'codsubareadetallada':
                    label = '*Sub-área detallada CINE/UNESCO: '
                    break;
                case 'anio':
                    label = 'Año de Publicación: ';
                    break;
                case 'palabrasClave':
                    label = '*Palabras Claves: '
                    break;
                case 'paginas':
                    label = '*Páginas: ';
                    break;
                case 'resumen':
                    label = '*Resumen: '
                    break;
                case 'iddecinvareaconocimiento':
                    label = '*Área prioritarias de investigación y vinculación: ';
                    break;
                case 'lineainvestigacion':
                    label = '*Línea de investigación y vinculación: ';
                    break;   
                default:
                    label = name;
                    break; 
            }
            break;
        case 46://ARTÍCULO DE CONFERENCIA (SCOPUS/WOS)
            switch(name){
                case 'adjunto':
                    label = '*Adjuntar PDF del Artículo científico'
                    break;
                case 'adjunto2':
                    label='*Certificado de asistencia a conferencia';
                    break;
                case 'adjunto3':
                    label='Adjuntar diapositivas (En caso de que aplique)';
                    break;
                case 'codISSN':
                    label = 'Código ISSN de la Revista: '
                    break;
                case 'cuartil':
                    label = 'Cuartil';
                    break;
                case 'impactoIndex':
                    label = 'Factor Impacto: ';
                    break;
                case 'impactoSJR':
                    label = 'Factor Impacto: ';
                    break;
                case 'impactoSciScore':
                    label = 'Factor Impacto: ';
                    break;
                case 'cuartilCiteScore':
                    label = 'Cuartil';
                    break;
                case 'esPrimerDecilCiteScore':
                    label = '¿Es Primer Decil?';
                    break;
                case "doi":
                    label = "*DOI: ";
                    break;
                case 'nevento':
                    label = 'Nombre Evento: '
                    break;
                case 'levento':
                    label = 'Lugar Evento: '
                    break;
                case 'fevento':
                    label = 'Fecha Evento: '
                    break;                        
                case 'palabrasClave':
                    label = '*Palabras Claves: '
                    break;
                case 'resumen':
                    label = '*Resumen: '
                    break;
                case 'idunidad':
                    label = 'Unidad: '
                    break;
                case "revisionpares":
                    label = "Tiene revisión por pares: ";
                    break;
                case 'tipolab':
                    label = 'Tipo Laboratorio: '
                    break;
                case 'fechapublicacion':
                    label = '*Fecha Publicación: '
                    break;
                case 'editorial':
                    label = 'Editorial: '
                    break;
                case 'nombreRevista':
                    label = '*Nombre de Revista/ Memoria de Evento: '
                    break;
                case 'url':
                    label = '*Url de Publicación: '
                    break;
                case 'urlRevista':
                    label = '*Url de la revista / Memoria de Evento: '
                    break;
                case 'volumen':
                    label = '*Volumen: ';
                    break;
                case 'paginas':
                    label = '*Páginas: ';
                    break;
                case 'especificacion':
                    label = 'Especificación: '
                    break;
                case 'iddecinvobjods':
                    label = 'ODS del producto: '
                    break;
                case 'codarea':
                    label = '*Área CINE/UNESCO: '
                    break;
                case 'codsubarea':
                    label = '*Sub-área CINE/UNESCO: '
                    break;
                case 'codsubareadetallada':
                    label = '*Sub-área detallada CINE/UNESCO: '
                    break;
                case 'anio':
                    label = '*Año de Publicación: ';
                    break;
                case 'iddecinvareaconocimiento':
                    label = '*Área prioritarias de investigación y vinculación: ';
                    break;
                case 'lineainvestigacion':
                    label = '*Línea de investigación y vinculación: ';
                    break;
                case 'bdrevista':
                    label = '*Tipo de indexación';
                    break;
                default:
                    label = name;
                    break;
            } 
            break;
        case 47://PRODUCTO DE TRANSCISION
            switch(name){
                case 'adjunto':
                    label = ''
                    break;
                case 'adjunto2':
                    label='';
                    break;
                case 'adjunto3':
                    label='';
                    break;
                case 'adjunto4':
                    label='';
                    break;
                case 'anio':
                    label='*Año: ';
                    break;
                case "doi":
                    label = "*DOI: ";
                    break;
                case "especificacion":
                    label = "*Especificaciones: ";
                    break;
                case "objGeneral":
                    label = "*Propósito: ";
                    break;                       
                case 'palabrasClave':
                    label = '*Palabras Claves: '
                    break;
                case 'resumen':
                    label = '*Resumen: '
                    break;
                case 'idunidad':
                    label = '*Unidad: '
                    break;
                case 'fechapublicacion':
                    label = '*Fecha Publicación: '
                    break;
                case 'editorial':
                    label = 'Editorial: '
                    break;
                case 'nombreRevista':
                    label = '*Nombre de Revista/ Memoria de Evento: '
                    break;
                case 'subclase': 
                    label = '*Producto Específico: ';
                    break;
                case 'url':
                    label = '*Url de Publicación: '
                    break;
                case 'asistObjetiv':
                    label = '';
                    break;
                case 'innovaVerific':
                    label = '';
                    break;
                case 'logrosSistemac':
                    label = '';
                    break;
                case 'retosComunic':
                    label = '';
                    break;
                default:
                    label = name;
                    break;
            } 
            break;
        default:
            switch(name){
                case 'codISSN':
                    label = 'Código ISSN de la Revista: '
                    break;
                case 'nevento':
                    label = 'Nombre Evento: '
                    break;
                case 'levento':
                    label = 'Lugar Evento: '
                    break;
                case 'fevento':
                    label = 'Fecha Evento: '
                    break;                        
                case 'palabrasClave':
                    label = 'Palabras Claves: '
                    break;
                case 'resumen':
                    label = 'Resumen: '
                    break;
                case 'idunidad':
                    label = 'Unidad: '
                    break;
                case 'tipolab':
                    label = 'Tipo Laboratorio: '
                    break;
                case 'fechapublicacion':
                    label = 'Fecha Publicación: '
                    break;
                case 'editorial':
                    label = 'Editorial: '
                    break;
                case 'nombreRevista':
                    label = 'Nombre de Revista/ Memoria de Evento: '
                    break;
                case 'url':
                    label = 'Url de Publicación: '
                    break;
                case 'especificacion':
                    label = 'Especificación: '
                    break;
                case 'iddecinvobjods':
                    label = 'ODS del producto: '
                    break;
                case 'codarea':
                    label = 'Área CINE/UNESCO: '
                    break;
                case 'codsubarea':
                    label = 'Sub-área CINE/UNESCO: '
                    break;
                case 'codsubareadetallada':
                    label = 'Sub-área detallada CINE/UNESCO: '
                    break;
                case 'anio':
                    label = 'Año de Publicación: ';
                    break;
                case 'iddecinvareaconocimiento':
                    label = 'Área de investigación: ';
                    break;
                case 'lineainvestigacion':
                    label = 'Línea de investigación: ';
                    break;
                case 'asistObjetiv':
                    label = 'Objetividad: ';
                    break;
                case 'innovaVerific':
                    label = 'Verificabilidad: ';
                    break;
                case 'logrosSistemac':
                    label = 'Sistematicidad: ';
                    break;
                case 'retosComunic':
                    label = 'Comunicabilidad: ';
                    break;
                default:
                    label = name;
                    break;
            }                
        break;
    }
    return label;
}

export function FormSubclaseLabelHandle(idsubclase:number,name:string):string{
    let label = ''
    switch(idsubclase){
        case 3830://Planta transgenica
            switch(name){
                case 'adjunto':
                    label = '*Adjuntar PDF del Producto'
                    break;
                case 'adjunto2':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'adjunto3':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'adjunto4':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'asistObjetiv':
                    label = '*Plantas modificadas genéticamente: ';
                    break;
                case 'innovaVerific':
                    label = '*Transformación genética: ';
                    break;
                case 'logrosSistemac':
                    label = '*Herramientas: ';
                    break;
                case 'retosComunic':
                    label = '*Conclusiones: ';
                    break;
                default:
                    label = '';
                    break;
            } 
            break;
        case 3831://Prototipo
            switch(name){
                case 'adjunto':
                    label = '*Adjuntar PDF del Producto'
                    break;
                case 'adjunto2':
                    label='Adjuntar Notificación de Aceptación (en caso de que exista)';
                    break;
                case 'adjunto3':
                    label='Adjuntar Prueba de Revisión de Pares (en caso de ser requerido)';
                    break;
                case 'adjunto4':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'asistObjetiv':
                    label = '*Plantas modificadas genéticamente: ';
                    break;
                case 'innovaVerific':
                    label = '*Transformación genética: ';
                    break;
                case 'logrosSistemac':
                    label = '*Colecciones: ';
                    break;
                case 'retosComunic':
                    label = '*Conclusiones: ';
                    break;
                default:
                    label = '';
                    break;
            } 
            break;
        case 3832://Secuencia sintética
            switch(name){
                case 'adjunto':
                    label = '*Adjuntar PDF del Producto'
                    break;
                case 'adjunto2':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'adjunto3':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'adjunto4':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'asistObjetiv':
                    label = '*Plantas modificadas genéticamente: ';
                    break;
                case 'innovaVerific':
                    label = '*Transformación genética: ';
                    break;
                case 'logrosSistemac':
                    label = '*Herramientas: ';
                    break;
                case 'retosComunic':
                    label = '*Conclusiones: ';
                    break;
                default:
                    label = '';
                    break;
            } 
            break;
        case 3833://Software
            switch(name){
                case 'adjunto':
                    label = '*Adjuntar PDF del Producto'
                    break;
                case 'adjunto2':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'adjunto3':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'adjunto4':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'asistObjetiv':
                    label = '*Plantas modificadas genéticamente: ';
                    break;
                case 'innovaVerific':
                    label = '*Transformación genética: ';
                    break;
                case 'logrosSistemac':
                    label = '*Herramientas: ';
                    break;
                case 'retosComunic':
                    label = '*Conclusiones: ';
                    break;
                default:
                    label = '';
                    break;
            } 
            break;
        case 3834://Vacuna
            switch(name){
                case 'adjunto':
                    label = '*Adjuntar PDF del Producto'
                    break;
                case 'adjunto2':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'adjunto3':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'adjunto4':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'asistObjetiv':
                    label = '*Plantas modificadas genéticamente: ';
                    break;
                case 'innovaVerific':
                    label = '*Transformación genética: ';
                    break;
                case 'logrosSistemac':
                    label = '*Colecciones: ';
                    break;
                case 'retosComunic':
                    label = '*Conclusiones: ';
                    break;
                default:
                    label = '';
                    break;
            } 
            break;
        case 3835://Transferencia tecnologia
            switch(name){
                case 'adjunto':
                    label = '*Adjuntar PDF del Producto'
                    break;
                case 'adjunto2':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'adjunto3':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'adjunto4':
                    label='Adjuntar otro tipo de evidencia';
                    break;
                case 'asistObjetiv':
                    label = '*Patentes Otorgadas: ';
                    break;
                case 'innovaVerific':
                    label = '*Transformación genética: ';
                    break;
                case 'logrosSistemac':
                    label = '*Herramientas: ';
                    break;
                case 'retosComunic':
                    label = '*Conclusiones: ';
                    break;
                default:
                    label = '';
                    break;
            } 
            break;
        default:
            label = '';
    }        
    return label;
}